import { render, staticRenderFns } from "./TblOrderDetail.vue?vue&type=template&id=175af440&scoped=true&"
import script from "./TblOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TblOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblOrderDetail.vue?vue&type=style&index=0&id=175af440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175af440",
  null
  
)

export default component.exports